module.exports = __webpack_public_path__ + "img/background-saas-details@2x.b8202ff1.jpg";